import React, { useState, useEffect, useRef } from "react";
import {
  Dialog as MuiDialog,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import styles from "./ChallengePaymentPage.module.css"; // Import CSS module
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import {
  isProduction,
  getCountryCode,
  open_api_with_cookies,
  open_api_without_auth,
} from "../../Utils/network";
import ConfirmationDialog from "../../Components/Dialog/ConfirmationDialog";
import LoadingOverlay from "../../Components/Dialog/LoadingOverlay";
import checkIcon from "../../Assets/dialog/checkIcon.svg";
import failureIcon from "../../Assets/dialog/failureIcon.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";
import CongratulationsBanner from "../../Components/SuccessCard/CongratulationsBanner";
import CustomAlert from "../../Components/AlertDialog/CustomAlert";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import GoogleSignIn from "../../Components/Login/GoogleSignIn";
import successIcon from "../../Assets/feedback/successIcon.svg";
import FailedIcon from "../../Assets/feedback/failedIcon.svg";
import {
  fetchCountryCode,
  validatePhoneNumber,
  validateEmail,
  handleOTPChange,
  handleKeyDown,
  handlePhoneNumberChange,
  handleEmailChange,
  applyCoupon,
  requestOTP,
  validateOTP,
  addAlert,
  removeAlert,
  fetchProfileTypes,
  handleCouponChange,
  checkUserInfoExists,
  fetchUserDetails,
  postExpertUserPurchase,
  validateGoogleLoginWithToken,
} from "../../Components/Dialog/helper";
import useAuth from "../../Components/Hook/useAuth";
import { GoogleLogin } from "@react-oauth/google";
import LoginCard from "../../Components/Login/LoginCard";
import ConfettiExplosionComponent from "../../Components/Coupon/ConfettiExplosionComponent";
import ConfettiExplosion from "react-confetti-explosion";

const ChallengePaymentPage = ({ open, onClose, challengeSlugFromProp }) => {
  const { challengeSlug: challengeSlugFromParams } = useParams();
  const challengeSlug = challengeSlugFromProp || challengeSlugFromParams; // Prioritize prop
  const [pageLoading, setPageLoading] = useState(true); // Renamed from 'loading' to avoid clash
  const [challengeData, setChallengeData] = useState(null);
  const [error, setError] = useState(null);

  // States from PaymentDialog - to be reviewed and adapted
  const [useEmail, setUseEmail] = useState(false);
  const [usePhone, setUsePhone] = useState(false);
  const [contactValue, setContactValue] = useState("");
  const [isVerified, setVerified] = useState(false);
  const [otpRequested, setOtpRequested] = useState(false);
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [otpValidated, setOtpValidated] = useState(false);
  const [firstName, setFirstName] = useState(""); // Renamed from setfirstName
  const [lastName, setLastName] = useState(""); // Renamed from setlastName
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [isPaymentSuccessful, setPaymentSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // This overlaps with 'loading' state, might need to consolidate
  const [dialogProps, setDialogProps] = useState({});
  const [firstNameError, setFirstNameError] = useState(false); // Renamed from setfirstNameError
  const [lastNameError, setLastNameError] = useState(false); // Renamed from setlastNameError
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [countryCode, setCountryCode] = useState("in");
  const inputRefs = useRef([]);
  const [coupon, setCoupon] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponFound, setCouponFound] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [newSellingPrice, setNewSellingPrice] = useState(0);
  const [matchingCoupon, setMatchingCoupon] = useState({});
  const [profileType, setProfileType] = useState("");
  const [profileTypeError, setProfileTypeError] = useState(false);
  const {
    isAuthenticated,
    userName,
    userId,
    bearerToken,
    setIsAuthenticated,
    setUserName,
  } = useAuth();
  const [isUserInfoExists, setIsUserInfoExists] = useState(false);
  //   const [expertDetailsList, setExpertDetailsList] = useState([]); // Challenges don't have experts in the same way
  const [message, setMessage] = useState("");
  const [enablePayButton, setEnablePayButton] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [popupCoupon, setPopupCoupon] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return; // Don't fetch if dialog is not open
    const fetchChallengeDetails = async () => {
      try {
        setPageLoading(true); // Use renamed state
        const response = await open_api_with_cookies.get(
          `/challenge/homepage/details/${challengeSlug}/`
        );
        if (response.status === 200) {
          setChallengeData(response.data);
          const initialSellingPrice =
            countryCode === "in"
              ? parseInt(response.data.selling_price)
              : parseInt(response.data.selling_price_usd);
          const initialMrpPrice =
            countryCode === "in"
              ? parseInt(response.data.mrp_price)
              : parseInt(response.data.mrp_price_usd);
          setNewSellingPrice(initialSellingPrice);
        } else {
          setError("Failed to load challenge details.");
        }
      } catch (err) {
        setError("An error occurred while fetching challenge details.");
        console.error("Error fetching challenge details:", err);
      } finally {
        setPageLoading(false); // Use renamed state
      }
    };

    fetchChallengeDetails();
  }, [challengeSlug, countryCode, open]);

  useEffect(() => {
    const fetchCountry = async () => {
      const code = await getCountryCode();
      setCountryCode(code);
    };
    fetchCountry();
  }, []);

  useEffect(() => {
    // Similar to PaymentDialog's updateUserDetails
    const updateUserDetails = async () => {
      if (isAuthenticated) {
        const sessionUseEmail = localStorage.getItem("useEmail");
        const sessionUsePhone = localStorage.getItem("usePhone");
        setUseEmail(sessionUseEmail === "true");
        setUsePhone(sessionUsePhone === "true");

        const userInfo = await fetchUserDetails(bearerToken, userId);
        if (userInfo) {
          setPhoneNumber(userInfo?.phone);
          setEmail(userInfo?.email);
          setFirstName(userInfo?.first_name);
          setLastName(userInfo?.last_name);
          const isUserInfoComplete = checkUserInfoExists(
            userInfo?.first_name,
            userInfo?.last_name,
            userInfo?.email,
            userInfo?.phone,
            sessionUseEmail === "true"
          );
          setIsUserInfoExists(isUserInfoComplete);
          if (isUserInfoComplete) {
            setEnablePayButton(true);
          }
        }
      }
    };
    updateUserDetails();
  }, [isAuthenticated]);

  const priceSymbol = countryCode === "in" ? "₹" : "$";
  const currencyType = countryCode === "in" ? "INR" : "USD"; // Renamed from isUSD
  const isUSD = countryCode === "in" ? "INR" : "USD";

  // --- Placeholder functions (to be implemented, based on PaymentDialog.js) ---
  const handleApplyCoupon = async () => {
    if (!challengeData) return;
    const currentSellingPrice =
      currencyType === "INR"
        ? parseInt(challengeData.selling_price)
        : parseInt(challengeData.selling_price_usd);
    const currentMrpPrice =
      currencyType === "INR"
        ? parseInt(challengeData.mrp_price)
        : parseInt(challengeData.mrp_price_usd);

    var couponToApply = coupon;
    console.log("isUSD", isUSD);
    const result = await applyCoupon(
      coupon,
      null,
      null,
      challengeData.id,
      currentSellingPrice,
      currentMrpPrice,
      setShowAlert,
      handleAddAlert,
      setCouponFound,
      setMatchingCoupon,
      setNewSellingPrice,
      setDiscountAmount,
      setCouponDiscount,
      setCoupon,
      isUSD
    );

    if (result.success) {
      setCouponFound(true);
      setShowConfetti(true);
      setPopupCoupon(couponToApply);
      setTimeout(() => setShowConfetti(false), 5000);
    } else {
      // Reset to non-coupon price if coupon invalid or removed
      setNewSellingPrice(currentSellingPrice);
      setDiscountAmount(currentMrpPrice - currentSellingPrice);
      setCouponDiscount(0);
    }
  };

  const handleAddAlert = (title, message, type, autoClose = false) => {
    addAlert(title, message, type, autoClose, setAlerts);
  };

  const handleRemoveAlert = (id) => {
    removeAlert(id, setAlerts);
  };

  const handleCloseDialog = () => {
    // Renamed from handleClosePage
    if (onClose) {
      onClose();
    }
    // Reset states if needed when dialog closes, or handle this in parent
    resetPaymentStates();
  };

  const getChallengePayData = async () => {
    if (!challengeData) return null;

    const localData = {
      challenge_id: challengeData.id,
      currency: currencyType,
      purchasedFrom: 1,
      ...(couponFound &&
        matchingCoupon.id && { coupon_code_id: matchingCoupon.id }),
    };

    try {
      setIsLoading(true);
      setMessage("Preparing your order...");
      const res = await open_api_with_cookies.post(
        `/challenge/purchase/create/cart/`,
        localData
      );
      const appliedCoupon = await applyCouponCode(challengeData);
      if (res?.status === 200 || res?.status === 201) {
        const paymentPayload = {
          challenge_purchase_id: res.data.id,
          amount: appliedCoupon.total_amt, // Use amount from purchase card response
        };
        const paymentRes = await open_api_with_cookies.post(
          `/payment/pay/`,
          paymentPayload
        );
        if (paymentRes?.status === 200 || paymentRes?.status === 201) {
          return {
            paymentData: paymentRes.data,
            challengePurchaseId: res.data.id,
          };
        }
      }
    } catch (err) {
      console.error("Error getting challenge pay data:", err);
      setShowAlert(true);
      handleAddAlert(
        "Order Error",
        err.response?.data?.detail ||
          "Could not prepare your order. Please try again.",
        "error",
        true
      );
    } finally {
      setIsLoading(false);
      setMessage("");
    }
    return null;
  };

  const applyCouponCode = async (challengeData) => {
    //console.log("couponcodeFound", couponFound);
    const localData = {
      challenge_id: challengeData.id ?? 0,
      ...(couponFound && { coupon_code_id: matchingCoupon.id ?? 0 }),
    };
    try {
      const res = await open_api_with_cookies.patch(
        `/challenge/purchase/update/cart/${challengeData.id}/`,
        localData
      );
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        const userDetails = res?.data?.user_detail;
        setPhoneNumber(userDetails?.phone);
        return res?.data || [];
      }
    } catch (error) {
      //console.log("failed to get coupon list");
    }
  };

  const initiateRazorpayPayment = async (paymentData, challengePurchaseId) => {
    if (!challengeData) return;
    setIsLoading(true);
    setMessage("Confirming your order, please don't close the screen...");

    const razorpayKey = isProduction
      ? "rzp_live_0MAqWVbokRW0Uu"
      : "rzp_test_41tt7Y8uKXr9rl";
    const options = {
      key: razorpayKey,
      amount: paymentData.amount * 100,
      currency: currencyType,
      name: "myburgo",
      description: `Payment for ${challengeData.title || "Challenge"}`,
      order_id: paymentData.order_id,
      timeout: 600,
      handler: (response) => {
        handlePaymentSuccess(
          paymentData.id,
          challengePurchaseId,
          response.razorpay_payment_id
        );
      },
      prefill: {
        name: `${firstName} ${lastName}`,
        email: email,
        contact: phoneNumber,
      },
      notes: {
        address: "website",
        challenge_purchase_id: challengePurchaseId,
      },
      theme: {
        color: "#7A53FF",
      },
      modal: {
        ondismiss: function () {
          if (!isPaymentSuccessful) {
            // check if payment was not already successful
            handlePaymentFailure(
              { error: "Payment window closed by user." },
              paymentData.id // cart_id
            );
          }
        },
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (response) => {
      if (!isPaymentSuccessful) {
        handlePaymentFailure(response, paymentData.id);
      }
    });
    rzp.open();
  };

  const fetchChallengeDetailsAndPay = async () => {
    if (!isUserInfoExists) {
      setShowAlert(true);
      handleAddAlert(
        "User Information Missing",
        "Please complete your profile information in the login section to proceed.",
        "error",
        true
      );
      return;
    }

    const result = await getChallengePayData();
    if (result && result.paymentData) {
      if (result.paymentData.amount === 0) {
        setIsLoading(true);
        setMessage("Confirming your registration...");
        handlePaymentSuccess(
          result.paymentData.id,
          result.challengePurchaseId,
          null
        ); // No razorpay_payment_id for free
      } else {
        await initiateRazorpayPayment(
          result.paymentData,
          result.challengePurchaseId
        );
      }
    }
  };

  const handlePaymentSuccess = async (
    cart_id,
    challengePurchaseId,
    razorpay_payment_id
  ) => {
    setIsLoading(true);
    setPaymentSuccessful(true); // Set early to prevent multiple calls from onDismiss or failed events
    setMessage("Finalizing your registration...");
    try {
      const localData = {
        is_bypassed: getDisplayPrice() === 0,
        ...(razorpay_payment_id && {
          razorpay_payment_id: razorpay_payment_id,
        }),
      };
      const res = await open_api_with_cookies.patch(
        `/payment/pay/${cart_id}/`,
        localData
      );

      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        var statusDescriptionText = `Your registration for the challenge "${challengeData?.title || "Challenge"}" is confirmed! 🎉`;
        if (getDisplayPrice() === 0) {
          statusDescriptionText = `You have successfully registered for the challenge "${challengeData?.title || "Challenge"}"! 🎉`;
        }
        setDialogProps({
          status: "success",
          statusText: "Thank you!",
          statusDescription: statusDescriptionText,
          statusIcon: successIcon,
          backgroundColor: "#FFFF",
          freeItem: getDisplayPrice() === 0, // Renamed prop
        });
        setConfirmationDialogOpen(true);
      } else {
        throw new Error(
          res.data?.detail || "Payment confirmation failed post-payment."
        );
      }
    } catch (err) {
      console.error("Error processing payment success:", err);
      setDialogProps({
        status: "failure",
        statusText: "Registration Issue",
        statusDescription:
          err.message ||
          "Your payment might have been successful, but we encountered an issue finalizing your registration. Please check 'My Learnings' or contact support at hello@myburgo.com.",
        statusIcon: FailedIcon,
        backgroundColor: "#FFFF",
      });
      setConfirmationDialogOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentFailure = async (response, cart_id) => {
    if (isPaymentSuccessful) return; // Already handled by success
    setIsLoading(true);
    setPaymentSuccessful(false); // Explicitly set to false
    setMessage("Processing payment failure...");
    console.error("Payment failed on Razorpay or closed:", response.error);
    try {
      // Optional: Inform backend about failure for cart_id if necessary.
      // E.g., await open_api_with_cookies.post(`/payment/challenge/failed/`, { cart_id: cart_id, reason: response.error?.description });
      setDialogProps({
        status: "failure",
        statusText: "Payment Failed",
        statusDescription:
          response.error?.description ||
          "There was an issue with the payment. Please try again or contact support at hello@myburgo.com if the problem persists.",
        statusIcon: FailedIcon,
        backgroundColor: "#FFFF",
      });
    } catch (err) {
      console.error("Error in handlePaymentFailure logic:", err);
    } finally {
      setIsLoading(false);
      setConfirmationDialogOpen(true);
    }
  };

  const handleCloseConfirmationDialog = () => {
    setConfirmationDialogOpen(false);
    if (dialogProps.status === "success") {
      // navigate("/my-learning"); // Navigation might be handled by parent or based on props
      if (onClose) onClose(); // Close the main payment dialog as well
    } else {
      resetPaymentStates();
    }
  };

  const resetPaymentStates = () => {
    setCoupon("");
    setCouponFound(false);
    setCouponDiscount(0);
    if (challengeData) {
      const initialSellingPrice =
        currencyType === "INR"
          ? parseInt(challengeData.selling_price)
          : parseInt(challengeData.selling_price_usd);
      setNewSellingPrice(initialSellingPrice);
      const initialMrpPrice =
        currencyType === "INR"
          ? parseInt(challengeData.mrp_price)
          : parseInt(challengeData.mrp_price_usd);
      setDiscountAmount(initialMrpPrice - initialSellingPrice);
    }
    setMessage("");
    setIsLoading(false);
    setPaymentSuccessful(false);
    setEnablePayButton(isUserInfoExists); // Re-enable pay button if user info is still valid
  };

  const handlePayEnable = (enable) => {
    setEnablePayButton(enable);
  };

  const handleUserInfoExists = (exists) => {
    setIsUserInfoExists(exists);
  };

  const getDisplayPrice = () => {
    if (!challengeData) return 0;
    const basePrice =
      currencyType === "INR"
        ? parseInt(challengeData.selling_price)
        : parseInt(challengeData.selling_price_usd);
    return couponFound ? newSellingPrice : basePrice;
  };

  const getMrpPrice = () => {
    if (!challengeData) return 0;
    return currencyType === "INR"
      ? parseInt(challengeData.mrp_price)
      : parseInt(challengeData.mrp_price_usd);
  };

  if (!open) {
    // If dialog is not open, don't render anything
    return null;
  }

  if (pageLoading) {
    return (
      <MuiDialog
        open={open}
        onClose={handleCloseDialog}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <LoadingOverlay message="Loading challenge details..." />
        </DialogContent>
      </MuiDialog>
    );
  }

  if (error) {
    return (
      <MuiDialog
        open={open}
        onClose={handleCloseDialog}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <div className={styles.errorContainer}>
            <p>{error}</p>
            <button onClick={handleCloseDialog}>Close</button>
          </div>
        </DialogContent>
      </MuiDialog>
    );
  }

  if (!challengeData) {
    return (
      <MuiDialog
        open={open}
        onClose={handleCloseDialog}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <LoadingOverlay message="Challenge data not available..." />
        </DialogContent>
      </MuiDialog>
    );
  }

  const currentMrp = getMrpPrice();
  const currentSelling =
    currencyType === "INR"
      ? parseInt(challengeData.selling_price)
      : parseInt(challengeData.selling_price_usd);
  const displayDiscountBanner =
    (couponFound && couponDiscount > 0) ||
    (!couponFound && currentMrp > currentSelling);
  const finalDiscountAmount = couponFound
    ? couponDiscount
    : currentMrp - currentSelling > 0
      ? currentMrp - currentSelling
      : 0;

  return (
    <MuiDialog
      open={open}
      onClose={handleCloseDialog}
      fullScreen={fullScreen}
      maxWidth={false}
      PaperProps={{
        sx: {
          overflowY: "visible",
          borderRadius: "12px",
          border: "none",
          background: "transparent",
          boxShadow: "none",
          margin: fullScreen ? "0" : "32px",
          padding: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
    >
      <div className={styles.pageContainer}>
        <div
          className={`${styles.dialogContainer} ${fullScreen ? styles.fullScreenOverride : ""}`}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: "12px",
              top: "12px",
              color: "#4A5568",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 10,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.95)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          {isLoading && <LoadingOverlay message={message} />}
          <div className={styles.rightSection}>
            <h1>Payment details</h1>
            <h2>Complete your purchase by providing your payment details.</h2>

            {isAuthenticated ? (
              <div className={styles.card}>
                <div className={styles.successMessage}>
                  <CheckCircleIcon
                    fontSize="small"
                    style={{ color: "#10B981" }}
                  />
                  You are logged in as {userName}
                </div>
              </div>
            ) : (
              <LoginCard
                setEnablePayButton={handlePayEnable}
                bypass={false}
                updateIsUserInfoExists={handleUserInfoExists}
                className="login-card"
              />
            )}

            {isAuthenticated && (
              <div className={styles.card}>
                <h3>Have a coupon code? Enter here</h3>
                <div className={styles.couponContainer}>
                  <input
                    type="text"
                    placeholder="Enter Coupon Code"
                    value={coupon}
                    onChange={(event) => handleCouponChange(event, setCoupon)}
                    disabled={isLoading}
                    className={styles.couponInput}
                  />
                  <button
                    onClick={handleApplyCoupon}
                    disabled={isLoading || !coupon.trim()}
                    className={styles.applyButton}
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
            <div className={styles.serviceCard}>
              <div className={styles.serviceDetails}>
                <div className={styles.serviceInfo}>
                  <h4>Service</h4>
                  <p>{challengeData.title}</p>
                </div>
                <div className={styles.servicePrice}>
                  <span className={styles.discountedPrice}>
                    {priceSymbol}
                    {couponFound ? newSellingPrice : currentSelling}
                  </span>
                </div>
              </div>
              {couponFound && couponDiscount > 0 && (
                <div
                  className={styles.serviceDetails}
                  style={{ marginTop: "8px" }}
                >
                  <div className={styles.serviceInfo}>
                    <p style={{ fontSize: "0.85rem", color: "#10B981" }}>
                      Coupon Discount
                    </p>
                  </div>
                  <div
                    className={styles.servicePrice}
                    style={{ fontSize: "0.85rem", color: "#10B981" }}
                  >
                    -{priceSymbol}
                    {couponDiscount}
                  </div>
                </div>
              )}
              <div className="divider"></div>
              <div className={styles.amountCard}>
                <div className={styles.amountLeft}>
                  <h4>Amount to be paid</h4>
                </div>
                <div className={styles.amountRight}>
                  <span className={styles.discountedPrice}>
                    {priceSymbol}
                    {getDisplayPrice()}
                  </span>
                </div>
              </div>
              {displayDiscountBanner && finalDiscountAmount > 0 && (
                <CongratulationsBanner
                  priceSymbol={priceSymbol}
                  discount={finalDiscountAmount}
                  style={{ marginTop: "16px" }}
                />
              )}
            </div>

            {isAuthenticated ? (
              <button
                className={styles.payButton}
                onClick={fetchChallengeDetailsAndPay}
                disabled={!enablePayButton || isLoading || pageLoading}
              >
                {isLoading
                  ? "Processing..."
                  : getDisplayPrice() === 0
                    ? "Register for Free"
                    : `Proceed to Pay ${priceSymbol}${getDisplayPrice()}`}
              </button>
            ) : (
              <p className={styles.loginPrompt}>
                Please log in to complete your registration.
              </p>
            )}
          </div>
          {showAlert &&
            alerts.map((alert) => (
              <CustomAlert
                key={alert.id}
                title={alert.title}
                message={alert.message}
                onClose={() => handleRemoveAlert(alert.id)}
                autoClose={alert.autoClose}
                type={alert.type}
              />
            ))}
        </div>
      </div>
      <ConfettiExplosionComponent
        open={showConfetti}
        onClose={() => setShowConfetti(false)}
        message={`Coupon "${popupCoupon}" applied! You saved ${priceSymbol}${couponDiscount}.`}
        coupon={popupCoupon}
      />
      {isConfirmationDialogOpen && (
        <ConfirmationDialog
          open={isConfirmationDialogOpen}
          onClose={handleCloseConfirmationDialog}
          image={
            challengeData?.hero_image || "/path/to/default_success_image.png"
          }
          title={
            dialogProps.status === "success"
              ? challengeData?.title || "Challenge Registration"
              : "Payment Status"
          }
          description={dialogProps.statusDescription}
          {...dialogProps}
          redirect={
            dialogProps.status === "success" ? "/my-learning" : undefined
          }
          countdownDuration={8}
        />
      )}
    </MuiDialog>
  );
};

export default ChallengePaymentPage;
